// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "input[data-v-9b5e3f1a]{border-color:#d8d8d8}", "",{"version":3,"sources":["webpack://./resources/js/components/Invitations/InviteRowMobile.vue"],"names":[],"mappings":"AACA,uBACE,oBAAF","sourcesContent":["\ninput {\n  border-color: #d8d8d8;\n}\n\n.permission_role>>>.multiselect__tags {\n  padding-bottom: 6px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
